import { Controller } from "@hotwired/stimulus"

// Zapis bieżącego wyszukiwania listy jako segment (Automation::SearchFilter) z poziomu stopki
// zwykłego formularza - bez otwierania panelu zaawansowanego. Zbiera zwykłe pola (query z
// FormData) oraz, jeśli jest, filtr zaawansowany (#advanced_filter_input -> conditions).
// Inline nazwa + checkbox współdzielenia; POST do API segmentów.
const QUERY_SKIP = ["filter", "page", "authenticity_token", "_method", "commit", "utf8", "set_view", "count"]

export default class extends Controller {
  static targets = ["form", "name", "shared", "msg"]
  static values = { url: String, subjectType: String, csrf: String, saved: String, error: String }

  // Pokazuje pole nazwy + checkbox dopiero po kliknięciu "Zapisz..." i ustawia na nim focus
  reveal() {
    this.formTarget.classList.remove("hidden")
    this.nameTarget.focus()
  }

  // Enter w polu nazwy zapisuje (bez submitu formularza wyszukiwania)
  keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    }
  }

  async save() {
    const name = this.nameTarget.value.trim()
    if (!name) { this.nameTarget.focus(); return }

    try {
      const res = await fetch(`${this.urlValue}.json`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this.csrfValue, Accept: "application/json" },
        body: JSON.stringify({
          search_filter: {
            name,
            subject_type: this.subjectTypeValue,
            shared: this.hasSharedTarget ? this.sharedTarget.checked : false,
            query: this.currentQuery(),
            conditions: this.currentConditions(),
          },
        }),
      })
      this.showMessage(res.ok)
      if (res.ok) this.nameTarget.value = ""
    } catch {
      this.showMessage(false)
    }
  }

  // Komunikat pod polem nazwy - zielony po zapisie, czerwony przy błędzie
  showMessage(ok) {
    this.msgTarget.textContent = ok ? this.savedValue : this.errorValue
    this.msgTarget.classList.toggle("text-green-700", ok)
    this.msgTarget.classList.toggle("text-red-600", !ok)
  }

  // Zwykłe pola formularza (q, status_ids, daty...) - z pominięciem filtra i pól technicznych
  currentQuery() {
    const form = this.element.closest("form")
    if (!form) return {}
    const query = {}
    for (const [key, value] of new FormData(form).entries()) {
      if (QUERY_SKIP.includes(key) || value === "") continue
      if (key.endsWith("[]")) {
        const k = key.slice(0, -2)
        ;(query[k] ||= []).push(value)
      } else {
        query[key] = value
      }
    }
    return query
  }

  // Filtr zaawansowany z ukrytego inputa (jeśli zbudowany), inaczej pusty
  currentConditions() {
    const input = document.getElementById("advanced_filter_input")
    if (!input || !input.value) return {}
    try {
      return JSON.parse(input.value)
    } catch {
      return {}
    }
  }
}
